<template>
  <v-combobox
    v-model="fieldValue"
    v-bind="comboboxProps"
    :search-input.sync="searchText"
    @keydown.enter.prevent="commit()"
    @blur="commit()"
  />
</template>

<script>
export default {
  name: "vCombobox",
  props: {
    value: { type: Object, required: true },
    config: { type: Object, required: true },
  },
  data: () => ({
    searchText: "",
  }),
  computed: {
    fieldValue: {
      get() {
        const key = this.config.vModel;
        return this.value ? this.value[key] : null;
      },
      set(val) {
        const key = this.config.vModel;
        this.$emit("input", { ...this.value, [key]: val });
      },
    },
    comboboxProps() {
      const { vModel, ...rest } = this.config || {};
      return rest;
    },
  },
  methods: {
    commit() {
      const pending = (this.searchText || "").trim();
      if (!pending) return;

      const current = Array.isArray(this.fieldValue)
        ? [...this.fieldValue]
        : [];

      // avoid duplicates (case-insensitive)
      const exists = current.some(
        (t) => String(t).toLowerCase() === pending.toLowerCase(),
      );
      if (!exists) current.push(pending);

      this.searchText = ""; // clear the input text
      this.fieldValue = current; // emit updated tags array into eventForm
    },
  },
};
</script>
